import styled from 'styled-components';
import { ModalLogoutStyled } from '../ModalLogoutStyled';
import { rem } from 'polished';

export const ModalLogoutStyledAP = styled(ModalLogoutStyled)`
    
`;
